import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { formatDateDefault, DEFAULT_DATE_FORMAT } from 'services/DateFormatters';
import { isValueEntered, isNumberValid } from 'services/Validation';
import moment from 'moment';
import { isDateBefore } from 'services/DateService';
import { INITIATIVE_STATUS } from 'constants/lists';


export const inputFields = (data, allProjects, handleUserInput, handleDateInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.status" />}</h3>
                <Input
                    type="select"
                    name="status"
                    id="statusSelect"
                    className={data?.status ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.status}
                >
                    <option key='emptySelect' value=''>-- select status --</option>
                    {INITIATIVE_STATUS.map((status) => {
                        return <option key={status} value={status}>{status}</option>;
                    })}
                </Input>
                <h3 className="card-heading" style={{ marginTop: 10 }}>{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading">{<IntlMessages id="label.project" />}</h3>
                <Input
                    type="select"
                    name="projectId"
                    id="projectSelect"
                    className={data?.projectId ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.projectId}
                >
                    <option key='emptySelect' value=''>-- select project --</option>
                    {allProjects.map((project) => {
                        return <option key={project.id} value={project.id}>{project.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.startDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="startDate"
                        value={formatDateDefault(data?.startDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('startDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.startDate),
                        }}
                    />
                </div>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.endDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="endDate"
                        value={formatDateDefault(data?.endDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('endDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.endDate),
                        }}
                    />
                </div>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.budget" />}</h3>
                <Input id="budget" type="text" className={`form-control mb-2 ${data?.budget ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event, true)}
                    defaultValue={data?.budget} name="budget"
                />
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedInitiative) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedInitiative?.thumb || 'assets/images/initiative-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const isFormValid = (selectedInitiative) => {
    return isValueEntered(selectedInitiative?.name) &&
        isValueEntered(selectedInitiative?.projectId) &&
        isValueEntered(selectedInitiative?.status) &&
        isNumberValid(selectedInitiative?.budget);
};

export const getFormError = (fieldName, value) => {
    let formError = '';
    switch (fieldName) {
        case 'name':
            formError = isValueEntered(value) ? '' : ' is invalid';
            break;
        default:
            break;
    }
    return formError;
};

export const checkDatesValid = (selectedInitiative) => {
    // console.log('checkDatesValid start');
    if (isValueEntered(selectedInitiative?.endDate) && isValueEntered(selectedInitiative?.startDate)) {
        // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
        if (isDateBefore(moment(selectedInitiative?.endDate), moment(selectedInitiative?.startDate))) {
            // console.log('checkDatesValid start ERRORS');
            return false;
        }
        // console.log('checkDatesValid start ALL GOOD');
        return true;
    }
    return true; // dates are not mandatory on features so dont return false - just check start is before end date
};


// WEBPACK FOOTER //
// ./components/Agile/initiative/initiativeMaintenance/common.js